import { render } from "./ReviewRegistrationForm.vue?vue&type=template&id=62a71102"
import script from "./ReviewRegistrationForm.vue?vue&type=script&lang=js"
export * from "./ReviewRegistrationForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__